export default {
  toolBox: {
    title: "Helpful Tip",
    text: "This profile can populate the following:",
    formsArray: [
      {
        formCommonName: "H-2A AGRICULTURAL CLEARANCE ORDER",
        formGovName: "FORM ETA-790",
        sections: ["ADDENDUM B"],
      },
    ],
  },
};
